/**
 * Public legal routes.
 *
 * These pages must be readable by people and by automated reviewers with no
 * account and no JavaScript: Google's OAuth verification fetches the privacy
 * policy, Grow (Meshulam) site approval fetches the terms, and the app stores
 * open both. Two consequences, enforced elsewhere in the tree:
 *
 *  1. BetaGate exempts them from the beta password (see isGateExemptPath).
 *  2. Providers passes them through without the i18n/auth client providers,
 *     so they render in the server HTML instead of only after hydration.
 *     This is safe ONLY because these pages render static generated content
 *     and call no client hooks — if that ever stops being true, remove the
 *     path from STATIC_LEGAL_PATHS rather than adding hooks.
 */
export const STATIC_LEGAL_PATHS = [
  "/terms",
  "/privacy",
  "/dpa",
  "/vendor-terms",
  "/en/terms",
  "/en/privacy",
  "/en/dpa",
  "/en/vendor-terms",
] as const;

export function isStaticLegalPath(pathname: string | null): boolean {
  if (!pathname) return false;
  return STATIC_LEGAL_PATHS.some((p) => pathname === p || pathname === `${p}/`);
}
